import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { BookingService } from '../service/booking.service';
import { UserService } from '../service/user.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { combineLatest, forkJoin, subscribeOn } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastMessageService } from '../toast-message.service';
import { BookingPreConfirmationService } from '../service/booking-pre-confirmation.service';
import { SimpleUser } from '../simple-user';
import { SchoolInvoiceService } from '../school-invoice.service';
import { PaymentToSupplierService } from '../service/payment-to-supplier.service';
import { PaymentReceivedService } from '../service/payment-received.service';
import { EmailSignatureService } from '../service/email-signature.service';
import { BookingEmailService } from '../service/booking-email.service';
import { BookingReportTemplate } from '../booking-report-template';
import { BookingDocumentTemplate } from '../booking-document-template';
import { BookingConfirmationTemplate } from '../booking-confirmation-template';
import { BookingFinalConfirmationTemplate } from '../booking-final-confirmation-template';
import { BookingViewModeService } from '../service/booking-view-mode.service';
import { BookingTransactionsComponent } from '../booking-transactions/booking-transactions.component';
import { BookingTransactionsService } from '../service/booking-transactions.service';
import { CurrencyService } from '../service/currency.service';
import { BookingPreConfirmationComponent } from '../booking-pre-confirmation/booking-pre-confirmation.component';
import { BookingAccommodationService } from '../service/booking-accommodation.service';
import { BookingAccommodationComponent } from '../booking-accommodation/booking-accommodation.component';
import { BookingStudentService } from '../service/booking-student.service';
import { BookingSummaryService } from '../service/booking-summary.service';
import { Booking } from '../booking';
import { ConstantContactService } from '../service/constant-contact.service';
import { Title } from '@angular/platform-browser';
import { BookingBrugesService } from '../service/booking-bruges.service';
import Decimal from 'decimal.js';
import { School } from '../school';
import { SalesAgent } from '../sales-agent';
import { EditBookingHighSchoolComponent } from '../edit-booking-high-school/edit-booking-high-school.component';
import { EditBookingImmersionComponent } from '../edit-booking-immersion/edit-booking-immersion.component';
import { ApiError } from '../api-error';
import { UserForBackend } from '../user-for-backend';
import { BrevoList } from '../brevo-list';
import { BrevoContact } from '../brevo-contact';

@Component({
  selector: 'app-edit-booking',
  templateUrl: './edit-booking.component.html',
  styleUrls: ['./edit-booking.component.css']
})
export class EditBookingComponent implements OnInit, OnDestroy {

  @ViewChild("transactionsComponent") transactionsComponent!: BookingTransactionsComponent;
  @ViewChild("preConfirmationComponent") preConfirmationComponent!: BookingPreConfirmationComponent;
  @ViewChild("accommodationComponent") accommodationComponent!: BookingAccommodationComponent;
  @ViewChild("editBookingHighSchoolComponent") editBookingHighSchoolComponent!: EditBookingHighSchoolComponent;
  @ViewChild("editBookingImmersionComponent") editBookingImmersionComponent!: EditBookingImmersionComponent;


  usingSmallScreen = false;
  assignedUsers: SimpleUser[] = [];
  userAssignForm!: FormGroup;
  counsellors: UserForBackend[] = [];
  lastOpenedMessage: string | null = null;
  serverErrorMessage: string | null = null;
  agents: SalesAgent[] = [];
  addingToSpreadSheet = false;
  displayBrevoDialog = false;
  brevoLists: BrevoList[] = [];
  targetBrevoLists: BrevoList[] = [];
  listBoxDisabled: boolean = false;
  isCreatingBrevoContact: boolean = false;
  selectedBrevoContact: BrevoContact | null = null;
  isUpdatingBrevoContact = false;
  brevoContactErrorMessage: string | null = null;
  isConnectingToBrevoServer = false;

  readonly SCREEN_SIZE_BREAKPOINT = 1500;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    public bookingService: BookingService,
    public userService: UserService,
    private favicon: FaviconService,
    private loginService: LoginService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    public bookingPreConfirmationService: BookingPreConfirmationService,
    public schoolInvoiceService: SchoolInvoiceService,
    public paymentToSupplierService: PaymentToSupplierService,
    public paymentReceivedService: PaymentReceivedService,
    public emailSignatureService: EmailSignatureService,
    public bookingEmailService: BookingEmailService,
    public bookingViewModeService: BookingViewModeService,
    private bookingTransactionsService: BookingTransactionsService,
    public currencyService: CurrencyService,
    private bookingAccommodationService: BookingAccommodationService,
    private bookingStudentService: BookingStudentService,
    private bookingSummaryService: BookingSummaryService,
    public constantContactService: ConstantContactService,
    private title: Title,
    private bookingBrugesService: BookingBrugesService
  ) {
    this.bookingViewModeService.initViewMode();
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }

  ngOnInit() {
    this.bookingService.isBookingReady = false;
    this.serverErrorMessage = null;
    let bookingId = Number(this.route.snapshot.paramMap.get("bookingId"));
    this.httpService.getGenders().subscribe(res => {
      this.bookingService.genders = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getAllCountries().subscribe(res => {
      this.bookingService.countryList = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getAllMotherLanguages().subscribe(res => {
      this.bookingService.motherLanguages = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBookingById(bookingId).subscribe(res => {
      this.title.setTitle(res.student.firstName + " " + res.student.lastName);
      this.configureBooking(res);
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });

    this.httpService.getBookingStatusByBookingId(bookingId).subscribe(res => {
      this.bookingService.selectedBookingStatus = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getAllLviBankInformations().subscribe(res => {
      this.bookingPreConfirmationService.bankInformations = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getStudentContactTypes().subscribe(res => {
      this.bookingStudentService.studentContactTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getTransportTypes().subscribe(res => {
      this.bookingService.transportTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBookingConfirmations(bookingId).subscribe(res => {
      this.bookingService.bookingConfirmations = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBookingFinalConfirmations(bookingId).subscribe(res => {
      this.bookingService.bookingFinalConfirmations = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getSalesProductTypes().subscribe(res => {
      this.bookingPreConfirmationService.productTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getCurrencies().subscribe(res => {
      this.currencyService.currencies = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });

    this.httpService.getAllPaymentTypes().subscribe(res => {
      this.bookingService.paymentTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getTargetLanguageLevels().subscribe(res => {
      this.bookingService.languageLevels = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getAccommodationTypes().subscribe(res => {
      this.bookingAccommodationService.accommodationTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getRoomTypes().subscribe(res => {
      this.bookingAccommodationService.roomTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBoardTypes().subscribe(res => {
      this.bookingAccommodationService.boardTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getTravelTypes().subscribe(res => {
      this.bookingService.travelTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getTransferTypes().subscribe(res => {
      this.bookingService.transferTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getLanguages().subscribe(res => {
      this.bookingService.languages = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getNationalities().subscribe(res => {
      this.bookingService.nationalities = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBookingReportsByBookingId(bookingId).subscribe(res => {
      this.bookingService.bookingReports = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getAllBookingFileTypes().subscribe(res => {
      this.bookingService.bookingFileTypes = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBookingStatuses().subscribe(res => {
      this.bookingService.bookingStatuses = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getAllTravelRequestCodes().subscribe(res => {
      this.bookingService.travelRequestCodes = [];
      this.bookingService.travelRequestCodes.push({ label: "x", value: null });
      for (let code of res) {
        this.bookingService.travelRequestCodes.push({ label: code.name, value: code });
      }
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getTargetLanguageLevels().subscribe(res => {
      this.bookingService.targetLanguageLevels = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getUserInfoByCookie().subscribe(res => {
      this.bookingService.user = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getBookingRequestComment(bookingId).subscribe(res => {
      this.bookingService.bookingRequestComment = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    this.httpService.getSalesAgents().subscribe(res => {
      this.agents = res;
    }, error => {
      let apiError = new ApiError(error);
      if (apiError.status && apiError.error && apiError.error.message) {
        this.serverErrorMessage = apiError.status + ": " + apiError.message;
      }
    });
    // forkJoin({
    //   motherLanguages: this.httpService.getAllMotherLanguages(),
    //   bookingStatus: this.httpService.getBookingStatusByBookingId(bookingId),
    //   bankInformations: this.httpService.getAllLviBankInformations(),
    //   studentContactTypes: this.httpService.getStudentContactTypes(),
    //   transportTypes: this.httpService.getTransportTypes(),
    //   bookingConfirmations: this.httpService.getBookingConfirmations(bookingId),
    //   bookingFinalConfirmations: this.httpService.getBookingFinalConfirmations(bookingId),
    //   salesProductTypes: this.httpService.getSalesProductTypes(),
    //   currencies: this.httpService.getCurrencies(),
    //   paymentTypes: this.httpService.getAllPaymentTypes(),
    //   languageLevels: this.httpService.getTargetLanguageLevels(),
    //   accommodationTypes: this.httpService.getAccommodationTypes(),
    //   roomTypes: this.httpService.getRoomTypes(),
    //   boardTypes: this.httpService.getBoardTypes(),
    //   travelTypes: this.httpService.getTravelTypes(),
    //   transferTypes: this.httpService.getTransferTypes(),
    //   languages: this.httpService.getLanguages(),
    //   nationalities: this.httpService.getNationalities(),
    //   genders: this.httpService.getGenders(),
    //   countryList: this.httpService.getAllCountries(),
    //   booking: this.httpService.getBookingById(bookingId),
    //   contactRequestQuotations: this.httpService.getContactRequestQuotationsByBookingId(bookingId),
    //   bookingReports: this.httpService.getBookingReportsByBookingId(bookingId),
    //   bookingFileTypes: this.httpService.getAllBookingFileTypes(),
    //   bookingStatuses: this.httpService.getBookingStatuses(),
    //   travelRequestCodes: this.httpService.getAllTravelRequestCodes(),
    //   targetLanguageLevels: this.httpService.getTargetLanguageLevels(),
    //   userInfo: this.httpService.getUserInfoByCookie(),
    //   bookingRequestComment: this.httpService.getBookingRequestComment(bookingId),
    //   salesAgents: this.httpService.getSalesAgents()
    // }).subscribe(({
    //   motherLanguages,
    //   bookingStatus,
    //   bankInformations,
    //   studentContactTypes,
    //   transportTypes,
    //   bookingConfirmations,
    //   bookingFinalConfirmations,
    //   salesProductTypes,
    //   currencies,
    //   paymentTypes,
    //   languageLevels,
    //   accommodationTypes,
    //   roomTypes,
    //   boardTypes,
    //   travelTypes,
    //   transferTypes,
    //   languages,
    //   nationalities,
    //   genders,
    //   countryList,
    //   booking,
    //   bookingReports,
    //   bookingFileTypes,
    //   bookingStatuses,
    //   travelRequestCodes,
    //   targetLanguageLevels,
    //   userInfo,
    //   bookingRequestComment,
    //   salesAgents
    // }) => {
    //   this.title.setTitle(booking.student.firstName + " " + booking.student.lastName);
    //   this.bookingService.bookingRequestComment = bookingRequestComment;
    //   this.bookingService.motherLanguages = motherLanguages;
    //   this.bookingService.selectedBookingStatus = bookingStatus;
    //   this.bookingPreConfirmationService.bankInformations = bankInformations;
    //   this.bookingStudentService.studentContactTypes = studentContactTypes;
    //   this.bookingService.transportTypes = transportTypes;
    //   this.bookingService.bookingConfirmations = bookingConfirmations;
    //   this.bookingService.bookingFinalConfirmations = bookingFinalConfirmations;
    //   this.bookingPreConfirmationService.productTypes = salesProductTypes;
    //   this.currencyService.currencies = currencies;
    //   this.bookingService.paymentTypes = paymentTypes;
    //   this.bookingService.languageLevels = languageLevels;
    //   this.bookingAccommodationService.accommodationTypes = accommodationTypes;
    //   this.bookingAccommodationService.roomTypes = roomTypes;
    //   this.bookingAccommodationService.boardTypes = boardTypes;
    //   this.bookingService.travelTypes = travelTypes;
    //   this.bookingService.transferTypes = transferTypes;
    //   this.bookingService.languages = languages;
    //   this.bookingService.nationalities = nationalities;
    //   this.bookingService.genders = genders;
    //   this.bookingService.countryList = countryList;
    //   this.bookingService.bookingReports = bookingReports;
    //   this.bookingService.bookingFileTypes = bookingFileTypes;
    //   this.bookingService.bookingStatuses = bookingStatuses;
    //   this.bookingService.targetLanguageLevels = targetLanguageLevels;
    //   this.bookingService.travelRequestCodes = [];
    //   this.bookingService.travelRequestCodes.push({ label: "x", value: null });
    //   this.bookingService.user = userInfo;
    //   this.agents = salesAgents;
    //   for (let code of travelRequestCodes) {
    //     this.bookingService.travelRequestCodes.push({ label: code.name, value: code });
    //   }
    //   this.configureBooking(booking);
    // }, error => {
    //   let apiError = new ApiError(error);
    //   if(apiError.status && apiError.error && apiError.error.message){
    //     this.serverErrorMessage = apiError.status + ": " + apiError.message;
    //   }
    // });
    this.verifyScreenWidth();
    this.bookingService.yearRange = (moment().year() - 10) + ":" + (moment().year() + 4);
    this.httpService.getBookingEmailHistoryByBookingId(bookingId).subscribe(res => {
      this.bookingService.emailHistories = res;
    }, error => {
      if (error.error) {
        this.toastService.addError("Error", error.error.message);
      } else {
        this.toastService.addError("Error", error);
      }
    });

    this.httpService.getBookingTempUserLogByBookingId(bookingId).subscribe(res => {
      if (res.length > 0) {
        this.lastOpenedMessage = "This booking has been opended by " + res[0].user.name + " at " + moment(res[0].timeStamp).format("YYYY/MM/DD HH[h]mm");
      }
    });
    this.initUserAssignForm(bookingId);
  }

  ngOnDestroy(): void {
    this.title.setTitle("LV Connect");
    this.bookingBrugesService.hasNoPicture = false;
  }

  configureBooking(booking: Booking) {
    booking.paymentToSupplierList = [];
    this.setPaymentReceived(booking);
    this.setSchoolInvoices(booking);
    this.setPaymentToSupplierList(booking);

    this.httpService.getSchoolContacts(booking.school.id!).subscribe(res => {
      this.bookingEmailService.schoolContacts = res;
    });
    this.bookingService.booking = booking;
    this.setInsuranceLists();
    this.httpService.getSchoolsByDestination(this.bookingService.booking.destination.id).subscribe(res => {
      this.bookingService.schoolList = res;
      this.verifyBookingSchoolCountryConsistency(res);
    });
    this.bookingService.updateBookingForm();
    this.bookingAccommodationService.initAccommodationForm();
    this.bookingTransactionsService.updateSchoolInvoices();
    this.bookingTransactionsService.initPaymentsReceived();
    this.bookingTransactionsService.initPaymentsToSchool();
    this.bookingService.checkBookingBrugesOrVnd();
    if (booking.school && booking.student.language) {
      this.bookingService.updateProgrammeInformationList(booking.school.id!, booking.student.language);
    }
    if (booking.school) {
      this.bookingService.googleSheetPriceUrl = booking.school.googleSheetUrl;
    }
    this.bookingService.isBookingReady = true;

    this.sortByOrder(booking.paymentReceivedList);
    this.sortByOrder(booking.schoolInvoiceList);
    this.sortByOrder(booking.paymentToSupplierList);

    if (booking.school != null) {
      this.httpService.getProgrammeTypesBySchoolId(booking.school.id!).subscribe(res => this.bookingService.programmeTypes = res);
    }
    this.bookingViewModeService.initNavigationItems();
    if (booking.school.id == environment.vndId || booking.school.id == environment.brugesId) {
      this.bookingService.isBrugesVndBooking = true;
      let brugesBooking = this.bookingService.bookingToBrugesVndBooking(booking);
      this.bookingService.booking = brugesBooking;
    } else {
      this.bookingService.isBrugesVndBooking = false;
    }
    this.bookingStudentService.initStudentForm();
    this.bookingStudentService.initStudentContactForm();
    this.bookingStudentService.initCommentForm();
    this.bookingPreConfirmationService.initPreConfirmationForm();
    let confirmationDate = moment().utc(true);
    if (booking.preConfirmation?.confirmationDate) {
      confirmationDate = moment(booking.preConfirmation.confirmationDate).utc(true);
    }
    this.bookingService.languageCourseList = booking.school.courseList;
    if (booking.preConfirmation) {
      this.bookingPreConfirmationService.initProducts(booking.preConfirmation.productList, confirmationDate);
    } else {
      this.bookingPreConfirmationService.addProduct();
    }
    this.bookingSummaryService.initTravelsForm();
    this.bookingStudentService.initStudentComments(booking.student.id!);
    this.updatePdfFileTemplates();
    this.bookingService.calculateAgeAtStartDate();
  }

  setInsuranceLists() {
    if (this.bookingService.booking.cancellationInsuranceSupplier || this.bookingService.booking.cancellationInsuranceRequested) {
      this.httpService.getCancellationInsuranceSuppliers().subscribe(res => {
        this.bookingService.cancellationInsuranceSuppliers = res;
      });
    }
    if (this.bookingService.booking.travelInsuranceSupplier || this.bookingService.booking.travelInsuranceRequested) {
      this.httpService.getTravelInsuranceSuppliers().subscribe(res => {
        this.bookingService.travelInsuranceSuppliers = res;
      });
    }
  }

  //If booking.school is not in the school list, add the school
  verifyBookingSchoolCountryConsistency(schools: School[]) {
    let isSchoolInTheList = false;
    for (let school of schools) {
      if (this.bookingService.booking.school.id == school.id) {
        isSchoolInTheList = true;
      }
    }
    if (isSchoolInTheList == false) {
      schools.push(this.bookingService.booking.school);
    }
  }

  setPaymentReceived(booking: Booking) {
    booking.paymentReceivedList = [];
    this.httpService.getPaymentsReceivedByBooking(booking.id!).subscribe(res => {
      for (let payment of res) {
        payment.amount = new Decimal(payment.amount);
        payment.created = moment(payment.created);
        payment.hidden = true;
      }
      booking.paymentReceivedList = res;
      this.paymentReceivedService.payments = res;
    });
  }

  setSchoolInvoices(booking: Booking) {
    booking.schoolInvoiceList = [];
    this.httpService.getSchoolInvoicesWithPaymentOrdersByBookingId(booking.id!).subscribe(res => {
      for (let invoice of res) {
        invoice.amount = new Decimal(invoice.amount);
        invoice.created = moment(invoice.created);
      }
      booking.schoolInvoiceList = res;
      this.schoolInvoiceService.invoices = res;
    });
  }

  setPaymentToSupplierList(booking: Booking) {
    booking.paymentToSupplierList = [];
    this.httpService.getPaymentsToSupplierByBookingId(booking.id!).subscribe(res => {
      for (let payment of res) {
        payment.amount = new Decimal(payment.amount);
        payment.created = moment(payment.created);
        payment.hidden = true;
      }
      booking.paymentToSupplierList = res;
      this.paymentToSupplierService.payments = res;
    });
  }

  updatePdfFileTemplates() {
    forkJoin({
      bookingReportTemplates: this.httpService.getBookingPdfDocumentTemplatesByLanguageId(this.bookingService.booking.student.language.id),
      bookingConfirmationTemplates: this.httpService.getBookingConfirmationTemplatesByLanguageId(this.bookingService.booking.student.language.id),
      bookingFinalConfirmationTemplates: this.httpService.getBookingFinalConfirmationTemplatesByLanguageId(this.bookingService.booking.student.language.id)
    }).subscribe(({
      bookingReportTemplates,
      bookingConfirmationTemplates,
      bookingFinalConfirmationTemplates
    }) => {
      this.bookingService.pdfTemplates = [];
      for (let item of bookingReportTemplates) {
        this.bookingService.pdfTemplates.push(
          new BookingDocumentTemplate(
            item.name,
            new BookingReportTemplate(item.body,
              item.name, item.documentType,
              item.documentLanguage, item.pdfDocumentCategory,
              item.id, item.created, item.createdBy, item.lastModified, item.lastModifiedBy)
          )
        );
      }
      for (let item of bookingConfirmationTemplates) {
        this.bookingService.pdfTemplates.push(
          new BookingDocumentTemplate(
            item.name,
            new BookingConfirmationTemplate(
              item.id,
              item.name
            )
          )
        );
      }
      for (let item of bookingFinalConfirmationTemplates) {
        this.bookingService.pdfTemplates.push(
          new BookingDocumentTemplate(
            item.name,
            new BookingFinalConfirmationTemplate(
              item.id,
              item.name
            )
          )
        );
      }
    });
  }

  initUserAssignForm(bookingId: number) {
    this.userAssignForm = this.builder.group({
      usersInCharge: this.builder.array([])
    });

    this.httpService.getCounsellors().subscribe(counsellors => {
      this.counsellors = counsellors;
      this.httpService.getUsersByBookingId(bookingId).subscribe(assignedUsers => {
        this.setCounsellors(counsellors, assignedUsers);
      });
    });
  }

  updateUsersInCharge() {
    let users: UserForBackend[] = this.getCheckedUsers();
    let simpleUsers: SimpleUser[] = [];
    for (let user of users) {
      simpleUsers.push(new SimpleUser(user.id!, user.name));
    }
    this.assignedUsers = simpleUsers;
    this.httpService.putAssignedUsersToBooking(this.assignedUsers, this.bookingService.booking.id!).subscribe(res => {
      this.toastService.addSuccess("Success", "Assigned users updated");
    }, error => {
      let apiError = new ApiError(error);
        this.toastService.addApiError(apiError);
    });
  }

  getCheckedUsers(): UserForBackend[] {
    let newUsers: UserForBackend[] = [];
    for (let j = 0; j < (this.userAssignForm.controls["usersInCharge"] as FormArray).length; j++) {
      if ((this.userAssignForm.controls["usersInCharge"] as FormArray).controls[j].value == true) {
        newUsers.push(this.counsellors[j]);
      }
    }
    return newUsers;
  }

  setCounsellors(users: UserForBackend[], assignedUsers: SimpleUser[]) {
    for (let counsellor of users) {
      let selected = false;
      for (let user of assignedUsers) {
        if (counsellor.id == user.id) {
          selected = true;
        }
      }
      (this.userAssignForm.controls["usersInCharge"] as FormArray).push(new FormControl(selected));
    }
  }

  verifyScreenWidth() {
    if (window.innerWidth < this.SCREEN_SIZE_BREAKPOINT) {
      this.usingSmallScreen = true;
    }
  }

  deactivateBooking() {
    this.httpService.deactivateBooking(this.bookingService.booking.id!).subscribe(() => {
      this.toastService.addSuccess("Success", "Booking is updated successfully");
      this.bookingService.booking.isActive = false;
    });
  }

  activateBooking() {
    this.httpService.activateBooking(this.bookingService.booking.id!).subscribe(() => {
      this.toastService.addSuccess("Success", "Booking is updated successfully");
      this.bookingService.booking.isActive = true;
    });
  }

  compareId(lang1: any, lang2: any) {
    return lang1 && lang2 ? lang1.id == lang2.id : lang1 == lang2;
  }

  updateBooking() {
    this.bookingService.sendingUpdateRequest = true;
    switch (this.bookingViewModeService.selectedView) {
      case this.bookingViewModeService.BOOKING_VIEW: {
        this.bookingSummaryService.update();
        break;
      }
      case this.bookingViewModeService.PRE_CONFIRMATION_VIEW: {
        this.preConfirmationComponent.updateConfirmation();
        break;
      }
      case this.bookingViewModeService.ACCOMMODATION_VIEW: {
        this.accommodationComponent.submitChange();
        break;
      }
      case this.bookingViewModeService.PAYMENTS_VIEW: {
        this.transactionsComponent.updateBookingDates();
        break;
      }
      case this.bookingViewModeService.STUDENT_VIEW: {
        this.bookingStudentService.updateStudent();
        break;
      }
      case this.bookingViewModeService.IMMERSION_VIEW: {
        this.editBookingImmersionComponent.submit();
        break;
      }
      case this.bookingViewModeService.HIGH_SCHOOL_VIEW: {
        this.editBookingHighSchoolComponent.submit();
        break;
      }
      case this.bookingViewModeService.FILES_VIEW: {
        this.bookingService.sendingUpdateRequest = false;
      }
    }
  }

  deleteBooking() {
    this.confirmationService.confirm({
      message: "Are you sure to delete this booking?",
      accept: () => {
        this.httpService.deleteBooking(this.bookingService.booking.id!).subscribe(() => {
          this.router.navigateByUrl("/management/bookings");
        }, error => {
          let apiError = new ApiError(error);
        this.toastService.addApiError(apiError);
        });
      }
    });
  }

  sortByOrder(array: any[]) {
    array = array.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) {
        return -1;
      }
      if (a.sortOrder > b.sortOrder) {
        return 1;
      }
      return 0;
    });
  }

  printBookingRequest() {
    this.httpService.getBookingRequestIdByBookingId(this.bookingService.booking.id!).subscribe(res => {
      if (res) {
        window.open("management/wp-booking-request-print/" + res, "_blank");
      } else {
        this.toastService.addError("Error", "This record is not created by booking request.");
      }
    });
  }

  callPhoneNumber() {
    if (!this.bookingService.booking.student.phoneNumber) {
      this.toastService.addError("Error", "There is no phone number to call");
      return;
    }
    let number = this.bookingService.booking.student.phoneNumber;
    let a = document.createElement("a");
    a.setAttribute("href", "tel:" + number);
    a.click();
  }

  updateSalesAgent() {
    let agent = this.bookingService.booking.salesAgent;
    this.httpService.updateBookingSalesAgent(this.bookingService.booking.id!, agent).subscribe(() => {
      this.toastService.addSuccess("Success", "Sales Agent updated");
    }, error => {
      let apiError = new ApiError(error);
      this.toastService.addApiError(apiError);
    });
  }

  get usersFormArray() {
    let usersForm = this.userAssignForm.get('usersInCharge') as FormArray;
    return usersForm.controls;
  }

  activateQuotationTemplateSavingDialog() {
    this.preConfirmationComponent.activateQuotationTemplateSavingDialog();
  }

  activatePreConfirmationForm() {
    this.preConfirmationComponent.activatePreConfirmationForm();
  }

  getQuotationTemplates() {
    this.preConfirmationComponent.getQuotationTemplates();
  }

  addBookingToSpreadSheet() {
    this.addingToSpreadSheet = true;
    this.httpService.appendGoogleSpreadSheet(this.bookingService.booking.id!).subscribe(() => {
      this.addingToSpreadSheet = false;
      this.toastService.addSuccess("Success", "Booking added to spreadSheet");
    }, error => {
      this.addingToSpreadSheet = false;
      this.toastService.addApiError(new ApiError(error));
    });
  }

  activateBrevoDialog() {
    this.brevoContactErrorMessage = null;
    this.displayBrevoDialog = true;
    if (!this.bookingService.booking.student.email) {
      console.error("this student has no email. cannot get brevo contact");
      this.brevoContactErrorMessage = "This student has no email. Please create one.";
    } else {
      this.isConnectingToBrevoServer = true;
      const student = this.bookingService.booking.student;
      this.httpService.getBrevoContactByEmail(student.email, student.firstName, student.lastName).subscribe(res => {
        this.selectedBrevoContact = res;
        this.httpService.getBrevoLists().subscribe(res => {
          this.brevoLists = res.lists;
          this.initBrevoList();
          this.isConnectingToBrevoServer = false;
        }, error => {
          let apiError = new ApiError(error);
          this.toastService.addApiError(apiError);
          this.isConnectingToBrevoServer = false;
        });
      }, error => {
        let apiError = new ApiError(error);
        this.toastService.addApiError(apiError);
        this.isConnectingToBrevoServer = false;
      });
    }
  }

  initBrevoList() {
    this.targetBrevoLists = [];
    for (let listId of this.selectedBrevoContact?.listIds!) {
      for (let list of this.brevoLists) {
        if (list.id === listId) {
          this.targetBrevoLists.push(list);
        }
      }
    }
  }

  selectBrevoList(target: BrevoList) {
    this.listBoxDisabled = true;
    for (let list of this.targetBrevoLists) {
      console.log(list);
      console.log(target);
      if (list.id === target.id) {
        this.listBoxDisabled = false;
        return;
      }
    }
    //if contact does not exist, create a new contact
    //if the contact already exists, update the contact with new lists
    this.targetBrevoLists.push(target);
    if (this.isCreatingBrevoContact) {
      // this.addConstantContact();
    } else {
      this.updateBrevoContact();
    }
    this.listBoxDisabled = false;
  }

  removeBrevoList(selectedList: BrevoList) {
    this.targetBrevoLists = this.targetBrevoLists.filter(list => {
      return list.id != selectedList.id;
    });
    this.updateBrevoContact();
  }

  updateBrevoContact() {
    if (!this.isUpdatingBrevoContact) {
      let contact = this.selectedBrevoContact;
      contact!.listIds = [];
      for (let list of this.targetBrevoLists) {
        contact!.listIds.push(list.id);
      }
      this.isUpdatingBrevoContact = true;
      this.httpService.updateBrevoContact(this.selectedBrevoContact!, this.selectedBrevoContact?.email!).subscribe(() => {
        this.toastService.addSuccess("Success !", "Contact updated");
        this.isUpdatingBrevoContact = false;
      }, error => {
        this.isUpdatingBrevoContact = false;
      });
    }
  }
}